// extracted by mini-css-extract-plugin
export default {"listItem":"PreregisterResume_listItem__4Ra1S","description":"PreregisterResume_description__0hTbP"};